import { ParkingArea, ParkingType, SlotStatus, Vehicle, ParkingStats, DefectLocation, VehicleDefect } from './types';

// Hotel location for Mumbai
export const HOTEL_LOCATION: [number, number] = [18.921, 72.833]; 

// Simplified parking area data that works with Leaflet
export const parkingAreas: ParkingArea[] = [
  {
    id: 'area1',
    name: 'Main Hotel Parking',
    type: ParkingType.DEDICATED,
    capacity: 50,
    occupied: 42,
    distance: 0.1,
    center: [18.9207, 72.8325],
    geofence: [
      [18.92094, 72.83300],
      [18.91839, 72.83185],
      [18.91833, 72.83206],
      [18.92087, 72.83318],
    ],
    slots: [
      {
        id: 'area1-slot1',
        name: 'A1',
        type: ParkingType.DEDICATED,
        status: SlotStatus.OCCUPIED,
        geofence: [
          [18.92087, 72.83316],
          [18.92088, 72.83313],
          [18.92084, 72.83312],
          [18.92083, 72.83314],
        ],
        center: [18.92085, 72.83313],
      },
      {
        id: 'area1-slot2',
        name: 'A2',
        type: ParkingType.DEDICATED,
        status: SlotStatus.AVAILABLE,
        geofence: [
          [18.92083, 72.83311],
          [18.92079, 72.83309],
          [18.92078, 72.83311],
          [18.92082, 72.83313],
        ],
        center: [18.92080, 72.83310],
      }
    ],
  },
  {
    id: 'area2',
    name: 'North Side Parking',
    type: ParkingType.RENTED,
    capacity: 35,
    occupied: 25,
    distance: 0.4,
    center: [18.9225, 72.8337],
    geofence: [
      [18.92214, 72.83359],
      [18.92209, 72.83371],
      [18.92220, 72.83377],
      [18.92229, 72.83378],
      [18.92241, 72.83375],
      [18.92254, 72.83366],
    ],
    slots: [
      {
        id: 'area2-slot1',
        name: 'B1',
        type: ParkingType.RENTED,
        status: SlotStatus.OCCUPIED,
        geofence: [
          [18.92221, 72.83361],
          [18.92223, 72.83360],
          [18.92225, 72.83362],
          [18.92222, 72.83363],
        ],
        center: [18.92223, 72.83361],
      }
    ],
  },
  {
    id: 'area3',
    name: 'East Side Parking',
    type: ParkingType.PUBLIC,
    capacity: 20,
    occupied: 10,
    distance: 0.7,
    center: [18.9232, 72.8330],
    geofence: [
      [18.92304, 72.83303],
      [18.92308, 72.83310],
      [18.92337, 72.83289],
      [18.92328, 72.83283],
    ],
    slots: [
      {
        id: 'area3-slot1',
        name: 'C1',
        type: ParkingType.PUBLIC,
        status: SlotStatus.AVAILABLE,
        geofence: [
          [18.92321, 72.83297],
          [18.92325, 72.83300],
          [18.92321, 72.83305],
          [18.92318, 72.83301],
        ],
        center: [18.92321, 72.83300],
      }
    ],
  },
  {
    id: 'area4',
    name: 'South Corner Parking',
    type: ParkingType.PUBLIC,
    capacity: 15,
    occupied: 5,
    distance: 1.0,
    center: [18.9235, 72.8327],
    geofence: [
      [18.92337, 72.83276],
      [18.92343, 72.83283],
      [18.92361, 72.83269],
      [18.92355, 72.83261],
    ],
    slots: [
      {
        id: 'area4-slot1',
        name: 'D1',
        type: ParkingType.PUBLIC,
        status: SlotStatus.AVAILABLE,
        geofence: [
          [18.92347, 72.83270],
          [18.92350, 72.83275],
          [18.92345, 72.83279],
          [18.92343, 72.83273],
        ],
        center: [18.92346, 72.83274],
      }
    ],
  },
];

// Generate more mock slots for each area
parkingAreas.forEach(area => {
  const baseSlots = [...area.slots];
  const slotsToAdd = area.capacity - baseSlots.length;
  
  if (slotsToAdd > 0) {
    for (let i = 0; i < slotsToAdd; i++) {
      const idx = baseSlots.length + i;
      const offsetLat = (Math.random() - 0.5) * 0.0005;
      const offsetLng = (Math.random() - 0.5) * 0.0005;
      
      const isOccupied = idx < area.occupied;
      
      area.slots.push({
        id: `${area.id}-slot${idx + 1}`,
        name: `${area.name.charAt(0)}${idx + 1}`,
        type: area.type,
        status: isOccupied ? SlotStatus.OCCUPIED : SlotStatus.AVAILABLE,
        center: [area.center[0] + offsetLat, area.center[1] + offsetLng],
        geofence: [
          [area.center[0] + offsetLat - 0.00005, area.center[1] + offsetLng - 0.00005],
          [area.center[0] + offsetLat + 0.00005, area.center[1] + offsetLng - 0.00005],
          [area.center[0] + offsetLat + 0.00005, area.center[1] + offsetLng + 0.00005],
          [area.center[0] + offsetLat - 0.00005, area.center[1] + offsetLng + 0.00005],
        ]
      });
    }
  }
});

// Car makes and models
const carMakes = [
  { make: 'Toyota', models: ['Camry', 'Corolla', 'Innova', 'Fortuner'] },
  { make: 'Honda', models: ['City', 'Civic', 'Accord', 'Amaze'] },
  { make: 'Hyundai', models: ['i20', 'Creta', 'Verna', 'Venue'] },
  { make: 'Maruti Suzuki', models: ['Swift', 'Dzire', 'Baleno', 'Brezza'] },
  { make: 'Tata', models: ['Nexon', 'Harrier', 'Safari', 'Tiago'] },
  { make: 'Mahindra', models: ['XUV700', 'Thar', 'Scorpio', 'XUV300'] },
  { make: 'Mercedes-Benz', models: ['E-Class', 'C-Class', 'GLC', 'S-Class'] },
  { make: 'BMW', models: ['3 Series', '5 Series', 'X3', 'X5'] },
  { make: 'Audi', models: ['A4', 'A6', 'Q5', 'Q7'] }
];

// Car colors
const carColors = ['White', 'Silver', 'Grey', 'Black', 'Blue', 'Red', 'Brown', 'Gold', 'Green'];

// Staff names
const staffNames = ['Rahul Sharma', 'Priya Patel', 'Amit Singh', 'Neha Gupta', 'Raj Kumar'];

// Common defects
const commonDefects = [
  { desc: 'Scratch', severity: 'MINOR' },
  { desc: 'Dent', severity: 'MODERATE' },
  { desc: 'Broken light', severity: 'MODERATE' },
  { desc: 'Paint chip', severity: 'MINOR' },
  { desc: 'Cracked windshield', severity: 'SEVERE' },
  { desc: 'Bumper damage', severity: 'MODERATE' },
  { desc: 'Tire wear', severity: 'MINOR' },
  { desc: 'Interior stain', severity: 'MINOR' },
  { desc: 'Door damage', severity: 'MODERATE' }
];

// Generate mock vehicles
export const vehicles: Vehicle[] = [];

parkingAreas.forEach(area => {
  const occupiedSlots = area.slots.filter(slot => slot.status === SlotStatus.OCCUPIED);
  
  occupiedSlots.forEach((slot, i) => {
    // Generate random car details
    const makeIndex = Math.floor(Math.random() * carMakes.length);
    const make = carMakes[makeIndex].make;
    const model = carMakes[makeIndex].models[Math.floor(Math.random() * carMakes[makeIndex].models.length)];
    const color = carColors[Math.floor(Math.random() * carColors.length)];
    const year = 2015 + Math.floor(Math.random() * 9); // Cars from 2015-2023
    const type = ['Sedan', 'SUV', 'Hatchback', 'Compact'][Math.floor(Math.random() * 4)];
    
    // Check-in times
    const hoursAgo = Math.floor(Math.random() * 48); // 0-48 hours ago
    const checkInTime = new Date(Date.now() - (hoursAgo * 60 * 60 * 1000)).toISOString();
    
    // Expected duration and charges
    const expectedDuration = Math.max(1, Math.floor(Math.random() * 24)); // 1-24 hours
    const baseRate = area.type === ParkingType.DEDICATED ? 200 : area.type === ParkingType.RENTED ? 150 : 100;
    const baseCharge = baseRate * Math.min(expectedDuration, 4); // First 4 hours at base rate
    const additionalCharge = Math.max(0, expectedDuration - 4) * (baseRate / 2); // Additional hours at half rate
    
    // Customer details
    const isGuest = Math.random() > 0.3; // 70% chance of being a hotel guest
    
    // Generate defects (0-3 defects per vehicle)
    const numDefects = Math.floor(Math.random() * 4); 
    const defects: VehicleDefect[] = [];
    
    for (let d = 0; d < numDefects; d++) {
      const defectType = commonDefects[Math.floor(Math.random() * commonDefects.length)];
      const locationIndex = Math.floor(Math.random() * Object.values(DefectLocation).length);
      const location = Object.values(DefectLocation)[locationIndex] as DefectLocation;
      
      defects.push({
        id: `defect-${area.id}-${i}-${d}`,
        location: location,
        description: defectType.desc,
        severity: defectType.severity as 'MINOR' | 'MODERATE' | 'SEVERE',
        reportedAtCheckIn: Math.random() > 0.2, // 80% reported at check-in
        notes: Math.random() > 0.7 ? 'Customer acknowledged the defect' : undefined
      });
    }
    
    // Staff who handled check-in
    const handledBy = staffNames[Math.floor(Math.random() * staffNames.length)];
    
    vehicles.push({
      id: `vehicle-${area.id}-${i + 1}`,
      licensePlate: `MH-${Math.floor(Math.random() * 99)}-${String.fromCharCode(65 + Math.floor(Math.random() * 26))}-${1000 + Math.floor(Math.random() * 9000)}`,
      make,
      model,
      year,
      color,
      type,
      slotId: slot.id,
      areaId: area.id,
      checkInTime,
      checkOutTime: null,
      expectedDuration,
      status: 'PARKED',
      charges: {
        base: baseCharge,
        additional: additionalCharge,
        total: baseCharge + additionalCharge,
        paid: false
      },
      customerDetails: isGuest ? {
        name: ['Vikram Malhotra', 'Anjali Desai', 'Karan Reddy', 'Meera Joshi', 'Arjun Kapoor'][Math.floor(Math.random() * 5)],
        contact: `+91 ${Math.floor(Math.random() * 10000000000)}`,
        email: Math.random() > 0.5 ? `guest${Math.floor(Math.random() * 1000)}@example.com` : undefined,
        roomNumber: `${Math.floor(Math.random() * 5) + 1}${Math.floor(Math.random() * 100) + 1}`,
        isGuest: true
      } : {
        name: ['Rohan Mehta', 'Sneha Singh', 'Dev Patel', 'Pooja Verma', 'Sanjay Kumar'][Math.floor(Math.random() * 5)],
        contact: `+91 ${Math.floor(Math.random() * 10000000000)}`,
        isGuest: false
      },
      defects,
      inspectionNotes: numDefects > 0 ? 'Vehicle inspection completed and defects noted' : undefined,
      handledBy
    });
  });
});

// Calculate total capacity and occupancy
const totalCapacity = parkingAreas.reduce((sum, area) => sum + area.capacity, 0);
const totalOccupied = parkingAreas.reduce((sum, area) => sum + area.occupied, 0);

// Calculate stats from the data
export const parkingStats: ParkingStats = {
  totalCapacity,
  totalOccupied,
  occupancyRate: Math.round((totalOccupied / totalCapacity) * 100),
  areaStats: parkingAreas.reduce(
    (acc, area) => ({
      ...acc,
      [area.id]: {
        capacity: area.capacity,
        occupied: area.occupied,
        rate: Math.round((area.occupied / area.capacity) * 100),
      },
    }),
    {}
  ),
  parkingTypeStats: Object.values(ParkingType).reduce(
    (acc, type) => {
      const areasOfType = parkingAreas.filter((area) => area.type === type);
      const capacity = areasOfType.reduce((sum, area) => sum + area.capacity, 0);
      const occupied = areasOfType.reduce((sum, area) => sum + area.occupied, 0);
      return {
        ...acc,
        [type]: {
          capacity,
          occupied,
          rate: capacity > 0 ? Math.round((occupied / capacity) * 100) : 0,
        },
      };
    },
    {
      [ParkingType.RENTED]: { capacity: 0, occupied: 0, rate: 0 },
      [ParkingType.PUBLIC]: { capacity: 0, occupied: 0, rate: 0 },
      [ParkingType.DEDICATED]: { capacity: 0, occupied: 0, rate: 0 },
    } as Record<ParkingType, { capacity: number; occupied: number; rate: number }>
  ),
  hourlyStats: Array.from({ length: 24 }, (_, hour) => {
    // Generate mock hourly data with peak at around 8-10 AM and 5-7 PM
    const peakFactor =
      hour >= 8 && hour <= 10
        ? 0.8 + Math.random() * 0.2
        : hour >= 17 && hour <= 19
        ? 0.7 + Math.random() * 0.3
        : 0.3 + Math.random() * 0.4;
    
    return {
      hour,
      occupied: Math.floor(peakFactor * totalCapacity),
    };
  }),
};